import lodash from 'lodash'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import {
  Col,
  FormRow,
} from '../../../../../../1stlog-ui/src/components/Bootstrap'
import Field, {
  useField,
  useFieldContext,
} from '../../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../../1stlog-ui/src/components/Input'
import Textarea from '../../../../../../1stlog-ui/src/components/Textarea'
import useOrderEntry from '../../../useOrderEntry'
import useRequiresConfirmation from './useRequireConfirmation'

const Wrapper = styled.div`
  min-width: 300px;
`

const RequireConfirmation = (props) => {
  const {} = props

  const { isInternal, currentCustomer } = useOrderEntry()

  const { prefix } = useFieldContext()

  const { isRequired } = useRequiresConfirmation({
    pickup: lodash.includes(prefix, 'pickup'),
    delivery: lodash.includes(prefix, 'delivery'),
  })

  const [email, setEmail] = useField('email', { asState: true })
  const [phone, setPhone] = useField('phone', { asState: true })
  const [infos, setInfo] = useField('infos', { asState: true })

  useEffect(() => {
    // console.log("currentCustomer", currentCustomer)
    if (lodash.isEmpty(email)) {
      // TODO: fill out from currentCustomer
      // setEmail("haarry potter")
    }
    if (lodash.isEmpty(phone)) {
      // TODO: fill out from currentCustomer
      // setPhone("")
    }
  }, [])

  if (!isRequired) {
    return null
  }

  return (
    <Wrapper>
      <h5 className="mb-1 mt-2">Auf Anfrage</h5>
      <div className="text-muted mb-1">
        {isInternal
          ? 'Diese Option ist nur auf Anfrage verfügbar. Bitte klären Sie vorab ab, ob der Auftrag entsprechend ausgeführt werden kann.'
          : 'Diese Option ist nur auf Anfrage verfügbar. Sobald Sie den Auftrag abgesendet haben, geben wir Ihnen umgehend Bescheid, ob wir diesen durchführen können. Bitte prüfen Sie unterhalb Ihre Telefonnummer und E-Mailadresse. Sollten Sie weitere Anmerkungen haben, bitte hier eintragen.'}
      </div>
      <FormRow>
        <Col md={6} sm={12}>
          <Field name="phone" label={i18n.t('phone', 'Telefon')}>
            <Input />
          </Field>
        </Col>
        <Col md={6} sm={12}>
          <Field name="email" label="E-Mail">
            <Input />
          </Field>
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <Field name="infos" label="Anmerkungen">
            <Textarea aplaceholder="Anmerkungen" />
          </Field>
        </Col>
      </FormRow>
    </Wrapper>
  )
}

export default RequireConfirmation
